module.exports = __webpack_public_path__ + "d3a17d2cfa3420a59411f4c9908fccb9.MP3";